module.exports = __webpack_public_path__ + "img/WGR.5363b48c.svg";